import { render, staticRenderFns } from "./language-switcher.vue?vue&type=template&id=2c9ae0c6"
import script from "./language-switcher.vue?vue&type=script&lang=js"
export * from "./language-switcher.vue?vue&type=script&lang=js"
import style0 from "./language-switcher.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports